import { styled } from 'styled-components';
import { useSelector } from 'react-redux';
import * as store from '../../../../reducers/store';

import { Col, Container, Row } from 'react-bootstrap';

import { api } from 'common';
import SearchBar from '../Common/SearchBar';
import { Link, match } from 'react-router-dom';
import { EmbeddedFluidContainer, StyledTypography } from '../Common';

interface Props {
  match: match;
  ipLocation?: api.IpStack.Response;
}

const Header: React.FC<Props> = ({ match, ipLocation }) => {
  const mastheadImageUrl: string | undefined = useSelector(
    (store: store.All) => store.theme?.mastheadImageUrl,
  );
  const embedded = useSelector((store: store.All) => store.embedded);
  return embedded ? (
    <EmbeddedFluidContainer fluid>
      <SearchBar match={match} ipLocation={ipLocation} border />
    </EmbeddedFluidContainer>
  ) : (
    <>
      <MastheadContainer backgroundImage={mastheadImageUrl}>
        <LimitedContainer>
          <FindProviderRow>
            <Col>
              <StyledTypography
                variant="headline-large"
                bold={true}
                color="knockout"
              >
                Find a Provider
              </StyledTypography>
            </Col>
          </FindProviderRow>
          <SearchTextRow>
            <Col>
              <StyledTypography
                className="w3-white"
                variant="paragraph-large"
                color="knockout"
              >
                Search through our network of providers based on your unique
                needs.
              </StyledTypography>
            </Col>
            <Col lg={4}>
              <AlignedDesktopDiv
                color="var(--color-white)"
                textDecoration="underline"
              >
                <StyledLink
                  color="var(--color-white)"
                  to={{
                    pathname: `${match.url}/search`,
                  }}
                >
                  Search all providers
                </StyledLink>
              </AlignedDesktopDiv>
            </Col>
          </SearchTextRow>
          <SearchBar match={match} ipLocation={ipLocation} />
          <AlignedMobileDiv
            color="var(--color-white)"
            textDecoration="underline"
          >
            <StyledLink
              color="var(--color-white)"
              to={{
                pathname: `${match.url}/search`,
              }}
            >
              Search all providers
            </StyledLink>
          </AlignedMobileDiv>
        </LimitedContainer>
      </MastheadContainer>
    </>
  );
};
export default Header;

const LimitedContainer = styled(Container)`
  @media (min-width: 1200px) {
    max-width: 1032px;
  }
`;

const MastheadContainer = styled.div.attrs<{ backgroundImage?: string }>(
  (props) => ({
    backgroundImage: props.backgroundImage,
  }),
)`
  background-image: url(${(props) => props.backgroundImage});
  background-size: cover;
  background-position: center center;
  background-color: var(--color-secondary);
  padding-top: 48px;
  padding-bottom: 24px;
  @media (min-width: 992px) {
    padding-bottom: 48px;
  }
`;

const FindProviderRow = styled(Row)`
  padding-bottom: 24px;
`;

const SearchTextRow = styled(Row)`
  padding-bottom: 24px;
  @media (min-width: 992px) {
    padding-bottom: 48px;
  }
`;

const AlignedDiv = styled.div.attrs<{ textDecoration: string }>((props) => ({
  textDecoration: props.textDecoration || 'none',
}))`
  text-align: right;
  text-decoration-line: ${(props) => props.textDecoration} !important;
  @media (max-width: 992px) {
    text-align: left;
  }
`;

const AlignedDesktopDiv = styled(AlignedDiv)`
  display: none;
  @media (min-width: 992px) {
    display: block;
  }
`;

const AlignedMobileDiv = styled(AlignedDiv)`
  padding-top: 24px;
  display: block;
  @media (min-width: 992px) {
    display: none;
  }
`;

const StyledLink = styled(Link).attrs<{ color: string }>((props) => ({
  color: props.color || 'var(--color-white)',
}))`
  color: ${(props) => props.color};
  :hover {
    color: ${(props) => props.color};
  }
`;
